import { Loader } from "@sazka/design-system/src/loader/loader";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { useSessionStorage } from "@sazka/utils/use-storage";
import { loadCasinoModule, ngCasinoModuleLoaded } from "./use-ng-casino";

const CHECKOUT_TIMEOUT = 20_000;

let depositTimeout = null;
const storageName = "active-game";
let store: ReturnType<typeof useSessionStorage>;
// eslint-disable-next-line
let initialized = false;

interface ActiveGame {
    gameId: number;
    moneyMode: boolean;
}

export const useCasinoCheckoutManager = async () => {
    await ensureManagerInitialized();

    async function ensureManagerInitialized() {
        if (initialized) return;
        initialized = true;

        store = useSessionStorage();
        const activeGame = store.getJson<ActiveGame>(storageName);
        if (activeGame?.gameId) {
            Loader.showNow("Čekáme na připsání peněz na váš účet.");
            depositTimeout = setTimeout(async () => {
                Loader.hide();
                showAlert({ title: "Peníze se nepodařilo připsat v limitu" });
                startGame(activeGame);
            }, CHECKOUT_TIMEOUT);
        }
    }

    function registerCheckoutCallbacks() {
        ng_hs.depositAborted(() => {
            clearTimeout(depositTimeout);
            onDepositStateChange();
        });

        ng_hs.depositSucceeded(() => {
            clearTimeout(depositTimeout);
            onDepositStateChange();
        });

        ng_hs.depositTimeout(() => onDepositStateChange());

        ng_hs.depositPending(() => onDepositStateChange());
    }

    function onDepositStateChange() {
        ng_hs.onStateChange((ngState) => {
            if (ngState === "idle") {
                const activeGame = store.getJson<ActiveGame>(storageName);
                store.removeItem(storageName);
                if (activeGame?.gameId) {
                    clearTimeout(depositTimeout);
                    Loader.hide();
                    startGame(activeGame);
                }
            }
        });
    }

    async function onDepositRedirectionStart() {
        if (!ngCasinoModuleLoaded) {
            return;
        }

        const { useNgCasino } = await loadCasinoModule();
        const { currentGameId, playForMoney } = useNgCasino();
        if (!currentGameId.value) {
            return;
        }

        const activeGame: ActiveGame = {
            gameId: currentGameId.value,
            moneyMode: playForMoney.value,
        };
        store.setJson(storageName, activeGame, "essential");
    }

    async function startGame(activeGame: ActiveGame) {
        store.removeItem(storageName);
        const { useNgCasino } = await loadCasinoModule();
        await useNgCasino().loadGame({ gameId: activeGame.gameId, moneyMode: activeGame.moneyMode });
    }

    return {
        registerCheckoutCallbacks,
        onDepositRedirectionStart,
    };
};
